import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { createUser, resetUserPassword, updateUser } from '../requests/users.request';
import { usersKey } from '../queries/users.query';
import { CreateUserRequest, UpdateUserRequest, UserSummary } from '../types/auth.types';

export const useCreateUserMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<UserSummary, AxiosError, CreateUserRequest>({
    mutationFn: createUser,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: usersKey })
  });
};

export const useUpdateUserMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<UserSummary, AxiosError, { id: string; request: UpdateUserRequest }>({
    mutationFn: ({ id, request }) => updateUser(id, request),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: usersKey })
  });
};

export const useResetUserPasswordMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<UserSummary, AxiosError, { id: string; temporaryPassword: string }>({
    mutationFn: ({ id, temporaryPassword }) => resetUserPassword(id, temporaryPassword),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: usersKey })
  });
};
